import React from "react";
import InputMask from "react-input-mask";
import { BaseTextFieldProps } from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  InputStyled,
  InputContainer,
  InputLabel,
  ErrorLabel,
} from "./Input.styles";
import { IconButton } from "@mui/material";

export interface InputPropsI extends BaseTextFieldProps {
  placeholder?: string;
  filled?: string;
  icon?: {
    direction: "start" | "end";
    icon: any;
  };
  error?: boolean;
  toggleVisible?: () => void;
  securityText?: boolean;
  errorMessage?: string;
  value?: string;
  mask?: string;
  enabled?: boolean;
  type?: "text" | "password" | "number";
  labelText?: string;
  variant?: "outlined";
  onChange?: (value: any) => void;
  sizeContainer?: "auto" | "small";
  centerValue?: boolean;
  maxLength?: number;
}
export const Input: React.FC<InputPropsI> = React.forwardRef(
  (
    {
      enabled,
      filled = "false",
      variant = "outlined",
      labelText,
      icon,
      mask,
      placeholder,
      onChange,
      toggleVisible,
      error,
      errorMessage,
      securityText = false,
      sizeContainer = "auto",
      centerValue = false,
      maxLength = undefined,
      type = "text",
      ...rest
    },
    ref: any
  ) => {
    const getIconPosition = () => {
      if (icon && icon.direction) {
        if (icon.direction === "end") return "endAdornment";
        if (icon.direction === "start") return "startAdornment";
      }
    };
    // const objIcon = icon ? {[`${getIconPosition()}`] : icon.icon} : {}

    const objIcon = () => {
      if (icon) {
        return { [`${getIconPosition()}`]: icon.icon };
      }
      if (toggleVisible) {
        return {
          endAdornment: (
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => {
                toggleVisible();
              }}
              edge="end"
            >
              {securityText ? (
                <Visibility sx={{ color: "#006BEE" }} />
              ) : (
                <VisibilityOff sx={{ color: "#006BEE" }} />
              )}
            </IconButton>
          ),
        };
      }
      return undefined;
    };

    return (
      <InputContainer sizeContainer={sizeContainer}>
        {labelText && <InputLabel enabled={enabled}>{labelText}</InputLabel>}
        {mask ? (
          <InputMask
            value={rest.value}
            mask={mask ? mask : ""}
            onChange={onChange}
            maskPlaceholder=""
            ref={ref && ref}
            // @ts-ignore:next-line
            maskChar={null}
          >
            {() => (
              <InputStyled
                filled={filled}
                InputProps={objIcon()}
                inputProps={{
                  style: { alignSelf: centerValue ? "center" : "auto" },
                  maxLength,
                }}
                type={securityText ? "password" : "text"}
                {...rest}
                placeholder={placeholder ? placeholder : mask}
              />
            )}
          </InputMask>
        ) : (
          <InputStyled
            ref={ref && ref}
            onChange={onChange}
            type={securityText ? "password" : type}
            filled={filled}
            InputProps={objIcon()}
            {...rest}
            placeholder={placeholder ? placeholder : mask}
            inputProps={{
              style: { textAlign: centerValue ? "center" : "left" },
              maxLength,
            }}
          />
        )}
        {error && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
      </InputContainer>
    );
  }
);
